module.exports = __webpack_public_path__ + "static/media/warehouse.ced4200a.png";